import { Icon } from '@iwoca/orion';
import clsx from 'clsx';
import styles from './FundingRequirement.module.css';
import { TDeserialisedFundingRequirement } from './fundingRequirements.helper';

type TProps = {
  requirement: TDeserialisedFundingRequirement;
};

export const FundingRequirement = ({ requirement }: TProps) => {
  const isCompleted = requirement.isCompleted;

  if (!requirement.label) {
    return null;
  }

  return (
    <li
      className={clsx(styles.fundingRequirement, {
        [styles.completed]: isCompleted,
      })}
    >
      <Icon
        data-testid={isCompleted ? 'complete-icon' : 'incomplete-icon'}
        className={styles.fundingRequirementIcon}
        icon={isCompleted ? 'checkCircleFilled' : 'hourglass'}
        height={24}
        width={24}
      />
      {requirement.label}
    </li>
  );
};
